import { postCreditCardIberiaCards } from '@nemuru-eng/js-api-client';

import { IberiaCardsStandsSelection } from '@/components/modules/Application/IberiaCards/_shared/types/IberiaCardsStandsSelection';
import { ShortContactFormType } from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/schemas/ShortContactForm.schema';

type PostCreditCardIberiaCardsRequest = Parameters<typeof postCreditCardIberiaCards>[0];

// PRD - IBC Stands, section 4.2
const STANDS_APPLICATION_CHANNEL = 'STAND-APP';
const INERIA_AGENCY_CODE = 'IA';
const STANDS_CHANNEL_CODE = 'ST';
// Backend requires corporate_group; campaigns without a "colectivo" have none
const NO_CORPORATE_GROUP = 0;

export class StandsCreditCardRequestMap {
  // cvd_ts = <sale point id> + <agency> + <agent code> + <channel>, e.g. MT4 + IA + 024 + ST
  public static toTrafficSource({ salePoint, agent }: IberiaCardsStandsSelection): string {
    return `${salePoint.id}${INERIA_AGENCY_CODE}${agent.code}${STANDS_CHANNEL_CODE}`;
  }

  public static toRequest(
    selection: IberiaCardsStandsSelection,
    contact: ShortContactFormType,
  ): PostCreditCardIberiaCardsRequest {
    const { salePoint, campaign } = selection;

    return {
      applicationInfo: {
        channel: STANDS_APPLICATION_CHANNEL,
        applicationOrigin: salePoint.applicationOrigin,
        marketingCampaign: campaign.campaign,
      },
      productInfo: {
        cardProduct: campaign.cardProduct,
        cardBrand: campaign.cardBrand,
        cardType: campaign.cardType,
        customerType: campaign.customerType,
        corporateGroup: campaign.corporateGroup ?? NO_CORPORATE_GROUP,
      },
      customer: {
        firstName: contact.firstName,
        lastName: contact.lastName,
        email: contact.email,
        phoneNumber: contact.dialCode ? `+${contact.dialCode.dialCode}${contact.phoneNumber}` : contact.phoneNumber,
        documentNumber: contact.documentNumber,
      },
      commercialTracking: {
        cvdTs: StandsCreditCardRequestMap.toTrafficSource(selection),
      },
    };
  }
}
